module.exports = __webpack_public_path__ + "/img/twingoZE-rezultati.d0e5adb1.webp";